import Vue from 'vue'
import Vuex from 'vuex'
import location from 'js/vue-plugins/vuex/modules/location'
import municipality from 'js/vue-plugins/vuex/modules/municipality'
import operators from 'js/vue-plugins/vuex/modules/operators'
import administrativeArea from 'js/vue-plugins/vuex/modules/administrative_area'
import map from 'js/vue-plugins/vuex/modules/map'
import country from 'js/vue-plugins/vuex/modules/country'
import appConfig from 'js/vue-plugins/vuex/modules/app-config'
import showProfileAccreditationRequests from
  'js/vue-plugins/vuex/modules/show_profile_accreditation_requests'
import entryPoint from 'js/vue-plugins/vuex/modules/entry-point'
import TopologyPointsService from 'js/services/api/topology/points'
// import transactionFilters from './modules/user/filters'
import user from 'js/vue-plugins/vuex/modules/user'
import planner from 'js/vue-plugins/vuex/modules/planner'
import API from 'js/services/api/index.js'
// Accessiblity
import accesibilityOptions from 'js/vue-plugins/vuex/modules/accessibility/accessibility_options'

// Runtime configuration (variables de entorno)
import runtimeConfig from 'js/vue-plugins/vuex/modules/runtime-config'

// Modals
import languageModal from 'js/vue-plugins/vuex/modules/modals/language_modal'
import helperVideo from 'js/vue-plugins/vuex/modules/modals/helper-video'
import accessibilityModal from 'js/vue-plugins/vuex/modules/modals/accessibility_modal'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    location,
    municipality,
    administrativeArea,
    map,
    country,
    languageModal,
    appConfig,
    showProfileAccreditationRequests,
    accesibilityOptions,
    accessibilityModal,
    helperVideo,
    entryPoint,
    ...user,
    operators,
    planner,
    runtimeConfig
  },

  state: {
    webTitle: WEB_TITLE,
    appCode: APP_CODE,
    localhost: IS_LOCAL,
    languages: LANGUAGES,
    language: localStorage.getItem('app-language') || LANGUAGES[0],
    fallbackLocale: FALLBACK_LANGUAGE || 'es',
    currentUser: null,
    device: 'desktop',
    selectedRouteId: undefined,
    selectedSublineId: undefined,
    loading: 0,
    notifications: [],
    maxBusTime: 3000, // Tiempo maximo de parada representable, en segundos
    stop: null,
    stops: [],
    favoriteStops: [],
    routes: [],
    filteredRoutes: [],
    route: {},
    pointsLoading: false,
    points: [],
    redirectFromIncidents: false,
    routesLoading: false

  },

  mutations: {
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser
    },

    incrementLoading(state) {
      state.loading += 1
    },

    decreaseLoading(state) {
      state.loading -= 1
    },

    setLanguage(state, language) {
      state.language = language
    },

    ADD_NOTIFICATION(state, notification) {
      state.notifications.push(notification)
    },

    UPDATE_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },

    setSelectedRouteId(state, routeId) {
      state.selectedRouteId = routeId
    },

    setSelectedSublineId(state, sublineId) {
      state.selectedSublineId = sublineId
    },

    setDevice(state, device) {
      state.device = device
    },

    setRedirectFromIncidents(state, value) {
      state.redirectFromIncidents = value
    },

    setStop(state, stop) {
      state.stop = stop
    },

    setStops(state, stops) {
      state.stops = stops
    },

    setPointsLoading(state, value) {
      state.pointsLoading = value
    },

    setPoints(state, points) {
      state.points = points
    },

    setFavoriteStops(state, stops) {
      state.favoriteStops = stops
    },

    setRoutesLoading(state, value) {
      state.routesLoading = value
    },

    setRoutes(state, routes) {
      state.routes = routes
    },

    setRoute(state, route) {
      state.route = route
    }
  },

  actions: {
    async loadCurrentUser() {
      return Vue.http.get('user')
        .then(response => {
          // devDump('USER RESONSE', response.data.data)
          const responseUser = response.data.data

          if (responseUser.role_name === 'Client') {
            Vue.auth.setUser(responseUser)

            return true
          }
          Vue.auth.logout()

          return false
        })
        .catch(error => {
          if (error.state === 401) {
            Vue.auth.setUser(undefined)
          }

          return false
        })
    },

    async loadMunicipalityStops({commit}, params) {
      // Obtenemos el recurso en el que queremos guardar las paradas requeridas
      const resource = params.resource || 'Stops'
      delete params.resource
      let route

      const stopsParams = {
        municipality_id: Vue.store.state.municipality.id,
        order_by: 'code',
        order_dir: 'asc',
        per: 0,
        template: 'complete'
      }

      if (params) {
        _.assign(stopsParams, params)
      }

      let promise
      if (resource === 'FavoriteStops') {
        promise = API.getFavoriteStops(stopsParams)
      } else {
        promise = API.getStops(stopsParams, true)
      }

      await API.getRoute(params.route_id).then(routeResponse => {
        route = routeResponse.data
      })

      promise.then(response => {
        _.each(response, stop => {
          stop.code_padded = stop.display_code.padStart(3, '0')
          stop.operator_id = route?.operator_ids?.[0]
        })

        commit(`set${resource}`, _.sortBy(response, 'code_padded'))
      })
    },

    async loadMunicipalityPoints({commit}, data) {
      commit('setPointsLoading', true)

      try {
        const params = {
          template: 'passenger_route',
          route_id: data.route_id,
          stops: true,
          order_by: 'distance_to_origin',
          order_dir: 'asc',
          page: 1,
          per: 0
        }

        const response = await TopologyPointsService.index({params, skipLoading: true})

        const routeStops = response.data
          .filter(stopData => stopData.stop !== null)
          .map(stopData => {
            const match = data.stops.find(stop => stop.code === stopData.stop.code)

            return {
              id: stopData.stop.id,
              name: stopData.stop.name,
              code: stopData.stop.code,
              correspondency: match?.correspondency || null,
              marker: match?.marker || null,
              display_code: stopData.stop.display_code,
              position: {
                lat: stopData.lat,
                lng: stopData.lng
              }
            }
          })

        commit('setPoints', routeStops)
      } catch (error) {
        console.error(error)
      } finally {
        commit('setPointsLoading', false)
      }
    },

    loadMunicipalityRoutes({commit}, params) {
      // Obtenemos el recurso en el que queremos guardar las rutas requeridas
      const resource = params.resource || 'Routes'
      delete params.resource

      commit('setRoutesLoading', true)
      const routes = []
      const routesParams = {
        municipality_id: Vue.store.state.municipality.id,
        order_by: 'direction',
        order_dir: 'asc',
        active: 1,
        per: 0
      }

      if (params) {
        _.assign(routesParams, params)
      }

      let promise
      if (resource === 'FavoriteRoutes') {
        promise = API.getFavoriteRoutes(routesParams)
      } else {
        promise = API.getRoutes(routesParams)
      }

      promise.then(response => {
        const route_ids = []
        _.forEach(response, route => {
          route.disabled = !route.subline_information
          route.active_incidences = []
          route_ids.push(route.id)

          routes.push(route)
        })

        // Se adelanta el dibujado de las rutas sin incidencias
        commit(`set${resource}`, _.sortBy(routes, ['subline_name']))
        commit('setRoutesLoading', false)

        // Si se han pedido junto con las incidencias, se piden ahora las incidencias
        if (params && params.incidences && route_ids.length > 0) {
          let rts = []
          const incidencesParams = {
            active: true,
            municipality_id: Vue.store.state.municipality.id,
            route_ids
          }
          API.getIncidences(incidencesParams).then(response2 => {
            _.forEach(response2, incidence => {
              rts = _.filter(routes, r =>
                _.includes(incidence.route_ids, r.id)
              )
              _.forEach(rts, r => {
                r.active_incidences.push(incidence)
              })
            })

            // Filtramos las incidencias obtenidas
            _.forEach(routes, route => {
              route.active_incidences = route.active_incidences.filter(
                incidence => incidence.broadcast_description_app_web !== ''
              )
            })

            commit(`set${resource}`, _.sortBy(routes, ['subline_name']))
            commit('setRoutesLoading', false)
          })
        }
      })
    }
  },

  getters: {
    localhost(state) {
      return state.localhost
    },

    currentUser(state) {
      return state.currentUser
    },

    loading(state) {
      return state.loading
    },

    clientAccounts(state) {
      return state?.currentUser?.client_accounts || []
    },

    currentClientAccount(state, getters, rootGetters) {
      // console.log('currentClientAccount init state', state)
      // console.log('currentClientAccount init getters', getters)
      // console.log('currentClientAccount init rootGetters', rootGetters)
      if (!Array.isArray(getters.clientAccounts)) {
        devDump('clientAccounts is not an array')

        return null
      }
      if (_.isEmpty(getters.clientAccounts)) {
        devDump('clientAccounts is empty')

        return null
      }
      if (_.isEmpty(getters['administrativeArea/administrativeAreaId'])) {
        devDump('No administrative area id available')

        return null
      }

      return getters.clientAccounts.find(clientAccount =>
        clientAccount.administrative_area_id === getters['administrativeArea/administrativeAreaId'])
    },

    device(state) {
      return state.device
    },

    isPortable(state) {
      return (state.device === 'tablet' || state.device === 'mobile')
    },

    redirectFromIncidents: state => state.redirectFromIncidents,

    stops: state => state.stops
  }
})

Vue.store = store

export default store
